import React from "react";
import PropTypes from 'prop-types';
import TopLogo from './TopLogo';
import MenuItems from './MenuItems';
import MenuUserItems from './MenuUserItems';
import Burger from './Burger';
import * as heroSectionModes from "../../constants/heroSectionModes";
import {isLandingPageEnabled} from "../../config/landing";

// how many pixels should be scrolled from the top
// to pin the top menu
const pinMenuOnScrollTop = 10;

export default class TopMenu extends React.PureComponent {
    state =  {
        menuHeight: 0,
        menuOffsetTop: 0,
        isPinned: false,
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleMenuScroll);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleMenuScroll);
    }

    handleMenuScroll = () => {
        let { menuHeight, isPinned } = this.state;

        if (menuHeight === 0) {
            return false;
        }

        let scrollTop = window.pageYOffset;

        if (!isPinned) {
            if (scrollTop > pinMenuOnScrollTop) {
                this.setState({isPinned: true});

                return false;
            }
        } else {
            if (scrollTop < pinMenuOnScrollTop) {
                this.setState({isPinned: false});

                return false;
            }
        }
    };

    render() {
        let {
            isLogged,
            toggleMobileMenu,
            isMobileMenuVisible,
            userData,
            isMenu,
            innerComponent,
            logout,
            className,
            isSignUpAvailable,
            heroSectionMode,
            registerPageView,
            isGetMePending,
        } = this.props;
        let { menuHeight, isPinned } = this.state;
        let menuClass = !isMobileMenuVisible && isPinned ? 'pinned' : 'unpinned';
        menuClass += isLandingPageEnabled ? ' landing-enabled' : ' landing-disabled' ;
        isMenu = typeof isMenu === 'undefined' ? true : isMenu;

        const isWhite = !isPinned && typeof className !== "undefined" && className.indexOf('features') >= 0 && !isMobileMenuVisible && heroSectionMode !== heroSectionModes.MODE_IMAGE;

        return (
            <div className={'top-menu ' + menuClass} ref={e => {
                if (menuHeight !== 0 || !e) {
                    return false;
                }

                let { height, top } = e.getBoundingClientRect();

                this.setState({menuHeight: height + top, menuOffsetTop: top});
            }}>
                <TopLogo
                    className={className}
                    isWhite={isWhite}
                />

                {isMenu ? <MenuItems/> : false}
                {innerComponent ? innerComponent : false}

                <MenuUserItems
                    registerPageView={registerPageView}
                    isSignUpAvailable={isSignUpAvailable}
                    isGetMePending={isGetMePending}
                    logout={logout}
                    isLogged={isLogged}
                    userData={userData}/>

                <Burger
                    isWhite={isWhite}
                    className={className}
                    onClick={toggleMobileMenu}/>
            </div>
        );
    }
}

TopMenu.propTypes = {
    innerComponent: PropTypes.node,
    isMenu: PropTypes.bool,
    userData: PropTypes.object.isRequired,
    isLogged: PropTypes.bool.isRequired,
    className: PropTypes.string,
    heroSectionMode: PropTypes.string,
    isMobileMenuVisible: PropTypes.bool.isRequired,
    isGetMePending: PropTypes.bool.isRequired,
    toggleMobileMenu: PropTypes.func.isRequired,
    registerPageView: PropTypes.func.isRequired,
    isSignUpAvailable: PropTypes.bool.isRequired,
};
